import { css, Interpolation } from 'styled-components';
import { DISPLAY_SIZE_ZOOM, DISPLAY_SIZES, DisplaySize } from '../../../utils/displaySize';

type PaneWidthFeature = 'min-width' | 'max-width';

/** Below this the task pane is a narrow strip: the gutter tightens and side-by-side content stacks. */
export const WIDE_PANE_MIN_WIDTH = 381;

const ROOT_SELECTOR_BY_SIZE: Record<DisplaySize, string> = {
  small: ":root[data-display-size='small']",
  normal: ":root:not([data-display-size='small'], [data-display-size='large'])",
  large: ":root[data-display-size='large']",
};

// Media queries measure the unzoomed pane, so the breakpoint is scaled to land on the same CSS width at every display size.
const paneWidthMedia = (feature: PaneWidthFeature, width: number, size: DisplaySize) =>
  `@media (${feature}: ${Number((width * DISPLAY_SIZE_ZOOM[size]).toFixed(2))}px)`;

export const atPaneWidth = (
  feature: PaneWidthFeature,
  width: number,
  styles: Interpolation<object>,
) =>
  DISPLAY_SIZES.map(
    (size) => css`
      :where(${ROOT_SELECTOR_BY_SIZE[size]}) & {
        ${paneWidthMedia(feature, width, size)} {
          ${styles}
        }
      }
    `,
  );

export const rootAtPaneWidth = (
  feature: PaneWidthFeature,
  width: number,
  declarations: Interpolation<object>,
) =>
  DISPLAY_SIZES.map(
    (size) => css`
      ${paneWidthMedia(feature, width, size)} {
        ${ROOT_SELECTOR_BY_SIZE[size]} {
          ${declarations}
        }
      }
    `,
  );

export const atZoomedDisplaySize = (styles: Interpolation<object>) => css`
  :where(${ROOT_SELECTOR_BY_SIZE.small}, ${ROOT_SELECTOR_BY_SIZE.large}) & {
    ${styles}
  }
`;
